/**
 * @author xiaohuangmaoth
 * @desc 内容新增/编辑
 * @date 2020-08-28
 */
import React from "react";
import { connect } from "dva";
import { framework_tool, component_tool, utils_tool } from "@/tool";
import ContentForm from "./components/contentForm";
import moment from 'moment'
import { formatAuth } from '@/utils/commonUtils'
// import style from './index.less'

const { WizContainer, modelUtils } = framework_tool;
const { WizSpin, WizButton } = component_tool;
const { Session } = utils_tool;

const hiddenTypeUrlEnum = {
  content: '/content/contentManage',
  learningMaterials: '/content/learningMaterialsManage'
}

const getDetailRecord = (history) => {
  let pathname = history.location.pathname;

  let detailInfo = ''
  const sessionName = pathname.split('/').filter(item => !!item).join('-') + '-Record'
  if (history?.location?.record) {
    detailInfo = history.location.record || {}
    Session.add(sessionName, detailInfo)
  } else {
    detailInfo = Session.get(sessionName) || {}
  }
  return detailInfo
}

class ContentDetail extends WizContainer {
  // 组件名 必传
  componentName = "ContentDetail";

  // 构造函数
  constructor(props) {
    super(props);
    this.state = {
      record: {},
      contentFormKey: 'contentFormKey'
    };

    if (['/content/learningMaterialsManage/learningMaterialsDetailAdd', '/content/learningMaterialsManage/learningMaterialsDetailUpd'].indexOf(props.history?.location?.pathname) !== -1) {
      this.hiddenType = 'learningMaterials';
    } else {
      this.hiddenType = 'content';
    }

    this.detailInfo = getDetailRecord(props.history)
    this.isupdate = !!props.history.location.pathname.includes("DetailUpd")
  }

  // 监听属性和状态的变化
  propsAndStateOnChange = {
    detailInfo: this._detailInfo.bind(this),
    add: this._add.bind(this),
    upd: this._upd.bind(this)
  };

  _detailInfo(nextProps, nextState) {
    const { detailInfo } = nextProps;
    if (detailInfo["success"] && detailInfo["data"]) {
      let contentTextList = detailInfo["data"]['contentTextList']
      if (contentTextList && contentTextList.length) {
        contentTextList = contentTextList.sort((a, b) => { return a.id - b.id })
      }
      nextState.record = { ...this.detailInfo, ...detailInfo.data, contentTextList };
      nextState.contentFormKey = new Date().getTime()
      return true;
    }
    return false;
  }

  _add(nextProps, nextState) {
    const { add, history } = nextProps;
    if (add["success"]) {
      wizNotice.success("保存成功");
      this.jumpPage('replace', hiddenTypeUrlEnum[this.hiddenType]);
      return true;
    } else {
      wizNotice.error(add["msg"] || "操作失败");
      return false;
    }
  }

  _upd(nextProps, nextState) {
    const { upd } = nextProps;
    if (upd["success"]) {
      wizNotice.success("保存成功");
      this.jumpPage('replace', hiddenTypeUrlEnum[this.hiddenType]);
      return true;
    } else {
      wizNotice.error(upd["msg"] || "操作失败");
      return false;
    }
  }

  _componentDidMount() {
    if (this.isupdate) {
      this.doAction({
        path: 'contentManage/detailInfo',
        payload: {
          key: 'detailInfo',
          apiParams: { id: this.detailInfo.id }
        },
      })
    }
  }

  // 格式化表单数据
  formatValues = values => {
    const vals = {
      releasePlatform: values.releasePlatform.join(','),
      releaseTime: moment(values.releaseTime).format('YYYY-MM-DD HH:mm:ss'),
      fileId: values.fileId[0].fileId,
      contentType: values['contentType'] || 1
    }

    vals.authCmd = formatAuth(values.authCmd)

    if (Object.prototype.toString.call(values.contentTextList) === "[object Object]") {
      const { watermark, contentType, contentText } = values.contentTextList
      let _o = contentType ? { contentType } : {}
      return { ...values, ...vals, watermark, contentTextList: contentText, ..._o }
    }

    return { ...values, ...vals }
  }

  // 提交表单
  handleSubmit = (values) => {
    const _values = this.formatValues(values)
    if(!_values.authCmd){
      wizNotice.warn("请选择内容受众");
      return;
    }else if( (!_values.authCmd.orgIds || !_values.authCmd.orgIds.length) &&
       (!_values.authCmd.personIds || !_values.authCmd.personIds.length) && 
      (!_values.authCmd.positionCategoryIds || !_values.authCmd.positionCategoryIds.length) && 
      (!_values.authCmd.positionIds ||  !_values.authCmd.positionIds.length) && 
      !_values.authCmd.groupId){
      wizNotice.warn("请选择内容受众");
      return;
    }
    const interfaceName = this.isupdate ? 'upd' : 'add'
    this.doAction({
      path: `contentManage/${interfaceName}`,
      payload: {
        key: interfaceName,
        apiParams: { ..._values }
      },
    })
  };

  // 渲染函数
  _render() {
    const { contentManageLoading } = this.props;
    const { record, contentFormKey } = this.state
    const contentFormProps = {
      key: contentFormKey,
      onSubmit: this.handleSubmit,
      record,
      contentType: record['contentType'] ? record['contentType'] : 1,
      isupdate: this.isupdate,
      hiddenType: this.hiddenType,
    }
    return (
      <WizSpin spinning={contentManageLoading}>
        <ContentForm {...contentFormProps} />
      </WizSpin>
    )
  }
}

// 数据源
const mapStateToProps = (state, ownProps) => {
  const { contentManage } = state;
  const add = modelUtils.getModelEntity(contentManage, 'add');
  const upd = modelUtils.getModelEntity(contentManage, 'upd');
  const detailInfo = modelUtils.getModelEntity(contentManage, 'detailInfo');
  const load = modelUtils.getLoadingState(state, 'contentManage');
  return {
    add,
    upd,
    detailInfo,
    ...load
  };
};

export default connect(mapStateToProps)(ContentDetail);
